import { SERVICE_REQUEST_TIMEOUTS } from '@bandido/shared/constants';
import { HotelItemHolderDTO } from '@bandido/shared/dtos';
import { client } from '@frontend/features/common/services';

export const cancelHotelItemBook = async (params: {
  saleOrderId: string;
  bookingId: number;
  bookingIdTGX: string;
  context: string;
}): Promise<boolean> => {
  try {
    const { data: status } = await client.post<boolean>('/sale-orders/cancellation/hotel', {
      ...params
    }, {
      timeout: SERVICE_REQUEST_TIMEOUTS.cancellation,
    });
    return status;
  } catch (_e) {
    return false;
  }
};

export const emitHotelItemBook = async (params: {
  saleOrderId: string;
  saleOrderItemId: string;
  clientReference: string;
  holder: HotelItemHolderDTO;
  socketId: string;
}): Promise<boolean> => {
  const { saleOrderItemId, socketId, ...rest } = params;
  try {
    const { data } = await client.post(
      `/sale-orders/item/${saleOrderItemId}/emit`,
      {
        ...rest,
      },
      {
        timeout: SERVICE_REQUEST_TIMEOUTS.booking,
        headers: {
          'socket-id': socketId,
        },
      },
    );
    return Boolean(data);
  } catch (_e) {
    return false;
  }
};
